// Temporary page: every project Typography variant, grouped as in
// components/Variants/Typography.jsx, with the rendered element, font size,
// weight and line height read from the computed style.
import React, { useEffect, useRef, useState } from "react"
import Typography from "aldoo-ra/Typography"
import projectVariants from "../Variants/Typography"

const GROUPS = [
  { title: "Headings", test: (n) => /^(title|h\d|product_title)/.test(n), sample: "Aldoo Snap - Lifetime License" },
  { title: "Body", test: (n) => n.startsWith("body"), sample: "Capture your screen, record video and share it in seconds. Works on Mac OS." },
  { title: "Text", test: (n) => /^(txt|caption)/.test(n), sample: "Оценете този продукт" },
  { title: "Labels", test: (n) => /^(label|badge)/.test(n), sample: "Дигитален продукт" },
  { title: "Specific", test: () => true, sample: "Screen Capture" },
]

const names = Object.keys(projectVariants)
const grouped = GROUPS.map((group, i) => ({
  ...group,
  names: names.filter((n) => group.test(n) && !GROUPS.slice(0, i).some((g) => g.test(n))),
}))

// footer_* are white text: shown on the footer's dark background
const onDark = (name) => name.startsWith("footer")

function VariantCard({ name, sample }) {
  const slot = useRef(null)
  const [spec, setSpec] = useState(null)

  useEffect(() => {
    const el = slot.current?.firstElementChild
    if (!el) return
    const s = getComputedStyle(el)
    setSpec({
      tag: el.tagName.toLowerCase(),
      size: s.fontSize,
      weight: s.fontWeight,
      leading: s.lineHeight,
    })
  }, [])

  return (
    <div className="flex flex-col gap-4 rounded-xl border border-bordered bg-white p-5">
      <div ref={slot} className={`min-h-[48px] rounded-lg p-3 ${onDark(name) ? "bg-dark" : ""}`}>
        <Typography variant={name}>{sample}</Typography>
      </div>
      <div className="mt-auto border-t border-bordered pt-3">
        <div className="font-mono text-[14px] font-bold text-text">{name}</div>
        <div className="font-mono text-[12px] text-text_secondary">
          {spec ? `<${spec.tag}> ${spec.size} / ${spec.weight} / lh ${spec.leading}` : "…"}
        </div>
        <div className="mt-1 break-words font-mono text-[11px] text-text_secondary">{projectVariants[name]}</div>
      </div>
    </div>
  )
}

export default function TypographyShowcasePage() {
  return (
    <div className="min-h-screen bg-canvas px-4 py-10 sm:px-8">
      <div className="mx-auto max-w-6xl">
        <h1 className="m-0 text-[28px] font-bold text-text">Typography variants</h1>
        <p className="mt-1 text-[15px] text-text_secondary">
          {names.length} project variants from components/Variants/Typography.jsx. Resize the window to see the responsive sizes.
        </p>

        {grouped.map(({ title, names, sample }) => (
          <section key={title} className="mt-10">
            <h2 className="m-0 mb-4 text-[20px] font-bold text-text">{title}</h2>
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {names.map((name) => (
                <VariantCard key={name} name={name} sample={sample} />
              ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  )
}
